import React from "react";
import PropTypes from "prop-types";

import useFeatureFlag from "frontend/hooks/useFeatureFlag";

/*
 * Determine which component to show based on if the user
 * has the given feature flag.
 *
 * NOTE:
 * Leave `oldComponent` blank if you don't want to show anything
 * if the user does not have the flag. Conversely, leave `newComponent`
 * blank to only show content if user does NOT have the flag.
 */
const RequireFeatureFlag = ({
    flag,
    oldComponent = null,
    newComponent = null
}) => {
    const hasFlag = useFeatureFlag(flag);
    return hasFlag ? newComponent : oldComponent;
};

RequireFeatureFlag.propTypes = {
    flag: PropTypes.string.isRequired,
    oldComponent: PropTypes.element,
    newComponent: PropTypes.element
};

export default RequireFeatureFlag;
